export default "__VITE_ASSET__0ffa2cbe__"